<template>
  <v-app>
    <SnackbarNotification />
    <router-view></router-view>
    <toast-container />
  </v-app>
</template>

<script>
import ToastContainer from './components/ToastContainer.vue';
import SnackbarNotification from "@/components/SnackbarNotification.vue";
import storageMixin from "@/mixins/storageMixin";

export default {
  name: "App",
   components: {
    ToastContainer,
    SnackbarNotification,
  },
  mixins: [storageMixin],
};
</script>
